import React from 'react';
import { Box, CheckBox } from "grommet";
import { Sun, Moon } from 'grommet-icons';
import PropTypes from 'prop-types';

const Header = props => {
    const { changeTheme, theme } = props;
    
    return (
        <Box
            direction="row"
            justify="end"
            alignSelf="center"
            gap="medium"
            pad={{ top: "large", horizontal: "xlarge" }}
        >
            <CheckBox
                checked={ theme === 'dark' ? true : false }
                onChange={ (event) => changeTheme(event.target.checked ? 'dark' : 'light') }
                label={ theme === 'dark' ? <Moon color='yellow' />  : <Sun color='orange' /> }
                toggle
            />
        </Box>
    )
}

Header.propTypes = {
    changeTheme: PropTypes.func,
    theme: PropTypes.string,
}

export default Header;